import React, { Component } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import API from "../utils/api";

class ForgotPasswordPage extends Component {
  state = {
    identifier: "",
    loading: false,
    sent: false,
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { identifier } = this.state;
    if (!identifier) {
      return toast.error("Email or mobile is required");
    }

    this.setState({ loading: true });
    try {
      await API.post("/auth/forgot-password", { identifier });
      toast.success("OTP sent successfully");
      this.setState({ sent: true });
    } catch (err) {
      const msg =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : "Failed to send OTP";
      toast.error(msg);
    }
    this.setState({ loading: false });
  };

  render() {
    const { identifier, loading, sent } = this.state;

    return (
      <div className="login-wrapper">
        <div className="login-box">
          <h2>
            <i className="fas fa-key"></i> Forgot Password
          </h2>
          {sent ? (
            <div>
              <p>
                An OTP has been sent to <strong>{identifier}</strong>.
              </p>
              <Link
                to={{ pathname: "/reset-password", search: `?identifier=${encodeURIComponent(identifier)}` }}
                className="btn btn-primary btn-block"
              >
                Enter OTP &amp; Reset Password
              </Link>
            </div>
          ) : (
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Email or Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  name="identifier"
                  value={identifier}
                  onChange={(e) => this.setState({ identifier: e.target.value })}
                  placeholder="Enter your email or mobile"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                {loading ? (
                  <span>
                    <i className="fas fa-spinner fa-spin"></i> Sending...
                  </span>
                ) : (
                  "Send OTP"
                )}
              </button>
            </form>
          )}
          <div className="text-center" style={{ marginTop: 12 }}>
            <Link to="/login">Back to login</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPasswordPage;
